import styled from "styled-components";

export const Wrapper = styled.div`
  .submit-form-container {
    margin: 0px !important;
    margin-top: -10px !important;
  }
  .ant-select-selector {
    height: 41px !important;
  }
  .ant-select-selection-item {
    margin-top: 6px !important;
    font-size: 17px;
  }
  .ant-select-selection-search {
    margin-top: 6px !important;
    font-size: 17px;
  }
`;
